import {getEndpointSchemeIdOptions} from "../../api/codelist/codeListsSlice";
import {useSelector} from "react-redux";
import {Controller} from "react-hook-form";
import {Autocomplete, TextField} from "@mui/material";
import {get} from "lodash";
import React from "react";

const EndpointSchemeIdSelect = ({
    name, label = 'Endpoint Scheme Id', control, errors, readOnly = false, disabled, onChange
}) => {
    const endpointSchemeIdOptions = useSelector(getEndpointSchemeIdOptions);

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => {
                return (
                    <Autocomplete
                        {...field}
                        id={name}
                        data-testid={`${name}-select`}
                        options={endpointSchemeIdOptions}
                        readOnly={readOnly}
                        getOptionLabel={(option) =>
                            option.label ? (option.code ? `${option.label} (${option.code})` : option.label) : ''
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                data-testid={`${name}-input`}
                                label={label}
                                error={!!get(errors, name, null)}
                                helperText={get(errors, name, {})?.message}
                            />
                        )}
                        isOptionEqualToValue={(option, value) => option.code === value?.code}
                        onChange={(_, value) => {
                            field.onChange(value);
                            onChange?.(value);
                        }}
                        value={field.value || null} // handle default value
                        disabled={disabled}
                    />
                );
            }}
        />
    );
};

export default EndpointSchemeIdSelect;
